import React, { useRef, useState } from "react";
import TextComponent from "../textComponent/TextComponent";
import styles from "./TopTab.module.css";

const TopTab = (props) => {
  return (
    <div className={`${styles.TopTabList} ${props?.TopTabListStyle}`}>
      {props?.options?.map((tab) => {
        return (
          <div
            key={tab.id}
            onClick={() => props?.setFocused(tab)}
            className={`${styles.tab} ${props?.TabStyle}  ${
              props?.focused?.name == tab.name
                ? `${styles.active} ${props?.ActiveTabStyle}`
                : ""
            }`}
          >
            <TextComponent
              text={tab.name}
              fontSize={"var(--mobile-subheading)"}
              className={props?.TabLabelStyle}
              padding={props?.TabLabelpadding ? props?.TabLabelpadding : "0px"}
              color={props?.TabLabelColor}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TopTab;
